import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoGrandi10Hb from "../grandi10hb/InfoGrandi10Hb";
const Footer = lazy(() => import('../footer/Footer'));
function Grandi10Hb() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="El Grand i10 hatchback es grandioso por donde lo mires. Es moderno y deportivo, perfecto para familia o amigos. Además, tiene el mejor equipamiento"
        />
        <meta
          name="keywords"
          content="Automóvil, Hatckback, Hyundai, Hyundai Grand i10, Grand i10 HB, i10, mejor automóvil"
        />
        <title>Hyundai Grand i10 Hatchback</title>
      </Helmet>
      <Menu />
      <InfoGrandi10Hb />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Grandi10Hb;